import Loader from "../loader";
import "./styles.css";

export const Button = (props) => {
  const {
    label,
    onClick,
    color = "text-white",
    width = "w-[358px] lg:w-[384px] max-[400px]:w-[100%]",
    disabled = false,
    onlyDisabled = false,
    icon,
    prefix = true,
  } = props || {};
  return (
    <div
      className={`h-11 ${width} bg-lightBlue hover:bg-purple-800 ${
        disabled || onlyDisabled ? "opacity-50" : ""
      } rounded-lg items-center justify-center flex`}
    >
      {disabled && !onlyDisabled ? (
        <Loader stroke="text-[#fff]" />
      ) : (
        <button
          onClick={onClick}
          className={`${width} ${color} h-11 font-semibold text-base  flex flex-row justify-center items-center px-3
            ${onlyDisabled && "cursor-not-allowed"}`}
          disabled={disabled || onlyDisabled}
        >
          {!!icon && prefix && (
            <img src={icon} alt="" className="mr-2 w-5 h-5" />
          )}
          {label}
          {!!icon && !prefix && (
            <img src={icon} alt="" className="ml-2 w-5 h-5" />
          )}
        </button>
      )}
    </div>
  );
};
